









































































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class StatementBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly currency!: any;

  @Prop() readonly toggleMode!: boolean;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly footerSummary!: number;

  utilsInstance = utils;
}
